// API service for lead-loop associations

export interface LeadLoop {
  id: number
  fub_person_id: number
  dotloop_loop_id: number
  dotloop_profile_id: number
  loop_name: string | null
  loop_url: string | null
  transaction_type: string | null
  created_at: string
}

export interface SaveLoopData {
  dotloop_loop_id: number
  dotloop_profile_id: number
  loop_name?: string
  loop_url?: string
  transaction_type?: string
}

// Get all loops associated with a FUB person/lead
export async function getLeadLoops(fubPersonId: number): Promise<LeadLoop[]> {
  const response = await fetch(`/api/leads/${fubPersonId}/loops`)
  
  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to fetch loops')
  }
  
  const data = await response.json()
  return data.loops
}

// Save a new loop association for a FUB person/lead
export async function saveLeadLoop(fubPersonId: number, loopData: SaveLoopData): Promise<LeadLoop> {
  const response = await fetch(`/api/leads/${fubPersonId}/loops`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(loopData)
  })
  
  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to save loop')
  }
  
  const data = await response.json()
  return data.loop
}

// Generate DotLoop URL from loop ID
export function getDotloopUrl(loopId: number): string {
  return `https://www.dotloop.com/my/loop/${loopId}`
}

export default {
  getLeadLoops,
  saveLeadLoop,
  getDotloopUrl
}
